import React from 'react';
import SchemaVersionsExpandable from './SchemaVersionsExpandable';
import {
  FileJson,
  History,
  Edit3,
  Plus,
  Sparkles,
  ChevronDown,
  ChevronUp,
  X
} from 'lucide-react';

const SchemaList = ({
  schemas,
  expandedSchemaId,
  onToggleVersions,
  onEditSchema,
  onCreateSchema,
  onConvertSample,
  loading,
  page,
  pageSize,
  totalCount,
  onPageChange
}) => {
  const totalPages = Math.ceil(totalCount / pageSize);

  return (
    <div className="schema-table-wrapper">
      <table className="schema-table">
        <thead>
          <tr>
            <th>Schema Contract Name</th>
            <th>Compliance Scope &amp; Description</th>
            <th style={{ textAlign: 'right' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="3" className="schema-table-state-cell">
                Loading registered schemas...
              </td>
            </tr>
          ) : schemas.length === 0 ? (
            <tr>
              <td colSpan="3" className="schema-table-empty-cell">
                <div className="schema-empty-state">
                  <div className="schema-empty-icon">
                    <FileJson size={28} />
                  </div>
                  <h4>No Tokenization Schemas Found</h4>
                  <p>
                    Create a schema visually, paste a Vaultize Schema JSON, or automatically convert a sample JSON payload into a validated schema.
                  </p>
                  <div className="schema-empty-actions">
                    {onConvertSample && (
                      <button
                        type="button"
                        className="btn-schema-ai-cta"
                        onClick={onConvertSample}
                      >
                        <Sparkles size={15} />
                        <span>Convert Sample JSON to Schema</span>
                      </button>
                    )}
                    {onCreateSchema && (
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={onCreateSchema}
                      >
                        <Plus size={15} />
                        <span>Create Schema</span>
                      </button>
                    )}
                  </div>
                </div>
              </td>
            </tr>
          ) : (
            schemas.map((s) => {
              const isExpanded = expandedSchemaId === s.id;
              return (
                <React.Fragment key={s.id}>
                  <tr className={isExpanded ? 'schema-row-active' : ''}>
                    <td>
                      <div className="schema-name-cell">
                        <FileJson size={16} className="schema-row-icon" />
                        <code className="schema-slug-badge">{s.name}</code>
                      </div>
                    </td>
                    <td className="schema-desc-cell">
                      {s.description || <span className="text-muted-italic">No description provided</span>}
                    </td>
                    <td className="schema-actions">
                      <button
                        type="button"
                        className="schema-action-pill"
                        onClick={() => onToggleVersions(s)}
                      >
                        <History size={14} />
                        <span>{isExpanded ? 'Hide Versions' : 'Versions'}</span>
                        {isExpanded ? <ChevronUp size={13} /> : <ChevronDown size={13} />}
                      </button>

                      <button
                        type="button"
                        className="schema-action-pill edit"
                        onClick={() => onEditSchema(s)}
                      >
                        <Edit3 size={14} />
                        <span>Edit Rules</span>
                      </button>
                    </td>
                  </tr>

                  {isExpanded && (
                    <tr className="schema-versions-row">
                      <td colSpan="3">
                        <div className="expanded-versions-header">
                          <span>
                            Immutable Version History for <strong>{s.name}</strong>
                          </span>
                          <button
                            type="button"
                            className="modal-close"
                            aria-label="Close"
                            onClick={() => onToggleVersions(s)}
                          >
                            <X size={18} />
                          </button>
                        </div>
                        <SchemaVersionsExpandable schema={s} />
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })
          )}
        </tbody>
      </table>

      {totalCount > pageSize && (
        <div className="pagination">
          <button
            className="btn btn-small"
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
          >
            Previous
          </button>

          <span>
            Page <strong>{page}</strong> of <strong>{totalPages}</strong>
          </span>

          <button
            className="btn btn-small"
            disabled={page >= totalPages}
            onClick={() => onPageChange(page + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default SchemaList;
